// extracted by mini-css-extract-plugin
export default {"table":"ViewAbout_table__2Ihhr","search":"ViewAbout_search__rPEI6","icons":"ViewAbout_icons__F-rAE"};